module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-summary"
  }, [_c('div', {
    staticClass: "tip-info"
  }, [(_vm.isRoundTrip) ? _c('div', [_c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('payment.leg')) + " 1: \n        ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [(_vm.discountValue && _vm.discountCode.code) ? _c('strong', [_c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg1DcOrig))))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.subTotalDiscounted))))])]) : _c('strong', [(_vm.leg1DcOrig != _vm.leg1Amount) ? _c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg1DcOrig))))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg1Amount))))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('payment.leg')) + " 2: \n        ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [(_vm.discountValue && _vm.discountCode.code) ? _c('strong', [_c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg2DcOrig))))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg2Amount))))])]) : _c('strong', [(_vm.leg2DcOrig != _vm.leg2Amount) ? _c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg2DcOrig))))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg2Amount))))])])])])]) : _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('payment.fare')) + ": \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [(_vm.discountValue && _vm.discountCode.code) ? _c('strong', [_c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg1DcOrig))))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.subTotalDiscounted))))])]) : _c('strong', [(!_vm.mtech.enabled && _vm.leg1DcOrig != _vm.subtotal && _vm.leg1DcOrig != -1) ? _c('s', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.leg1DcOrig))))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.subtotal))))])])])]), _vm._v(" "), (_vm.showConvenienceFee) ? _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n        Convenience Fee:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('strong', [_c('span', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.convenienceFee))))])])])]) : _vm._e(), _vm._v(" "), (_vm.showTravelInsurance) ? _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payment.riderFee')) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.travelInsurance))))])])]) : _vm._e(), _vm._v(" "), (_vm.showAirportFee) ? _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payment.airportFee')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.airportFee))))])])]) : _vm._e(), _vm._v(" "), (_vm.showGasFee) ? _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('payment.fuelSurcharge')) + ": ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.gasFee))))])])]) : _vm._e(), _vm._v(" "), (_vm.showMeetAndGreet) ? _c('div', {
    staticClass: "row margin-b-s"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('payment.mng')) + " \n      ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('strong', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.meetAndGreetFee))))])])]) : _vm._e(), _vm._v(" "), (!_vm.isAsap && !_vm.lyft.enabled) ? _c('div', {
    staticClass: "margin-b-s"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_vm._v(_vm._s(_vm.$t('payment.tip')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [(_vm.currency.code === 'USD') ? _c('strong', [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.tip), true, false)))]) : _c('strong', [_vm._v(_vm._s(_vm.xcurrency.format({
    code: _vm.currency.code,
    val: _vm.tipIntl
  })))]), _vm._v(" "), _c('a', {
    staticClass: "add-tip",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toggleTipForm
    }
  }, [_vm._v(_vm._s(_vm.tipLabel))])])]), _vm._v(" "), _c('div', {
    staticClass: "row padding-h-m"
  }, [_c('div', {
    staticClass: "small-8 small-offset-4 medium-6 medium-offset-6 columns"
  }, [_c('div', {
    class: ['tip-form' + (_vm.showTipForm ? '' : ' hidden')]
  }, [_c('div', {
    staticClass: "field-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTip),
      expression: "selectedTip"
    }],
    class: ['field-text field-select' + (_vm.showCustomTip ? ' hide' : '')],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTip = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onTipSelected]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.applyCurrency('0.00', true, false)))]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.tipBreakdown.ten
    }
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.tipBreakdown.ten), true, false)) + " (10%)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.tipBreakdown.fifteen
    }
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.tipBreakdown.fifteen), true, false)) + " (15%)")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.tipBreakdown.twenty
    }
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.tipBreakdown.twenty), true, false)) + " (20%)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v(_vm._s(_vm.$t('payment.custom')))])]), _vm._v(" "), (_vm.currency.code === 'USD') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.showCustomTip),
      expression: "showCustomTip"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.customTip),
      expression: "customTip",
      modifiers: {
        "number": true
      }
    }],
    class: ['field-text custom-tip' + (_vm.showCustomTip ? '' : ' hide')],
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "placeholder": _vm.$t('payment.enterTip')
    },
    domProps: {
      "value": (_vm.customTip)
    },
    on: {
      "keypress": _vm.isNumber,
      "blur": [function($event) {
        _vm.validateTip('customTip')
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customTip = _vm._n($event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus",
      value: (_vm.showCustomTip),
      expression: "showCustomTip"
    }, {
      name: "model",
      rawName: "v-model.number",
      value: (_vm.tipIntl),
      expression: "tipIntl",
      modifiers: {
        "number": true
      }
    }],
    class: ['field-text custom-tip' + (_vm.showCustomTip ? '' : ' hide')],
    attrs: {
      "type": "number",
      "pattern": "\\d*",
      "placeholder": _vm.$t('payment.enterTip')
    },
    domProps: {
      "value": (_vm.tipIntl)
    },
    on: {
      "keypress": _vm.isNumber,
      "blur": [function($event) {
        _vm.validateTip('tipIntl')
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tipIntl = _vm._n($event.target.value)
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "op-btn btn-block btn-success",
    on: {
      "click": _vm.addTip
    }
  }, [_vm._v(_vm._s(_vm.tipLabel))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.mtech.enabled) ? _c('div', _vm._l((_vm.mtechFees), function(fee, i) {
    return _c('div', {
      key: i,
      staticClass: "row margin-b-s"
    }, [_c('div', {
      staticClass: "small-4 columns summary-label"
    }, [_c('span', [_vm._v(_vm._s(fee.description) + ":")])]), _vm._v(" "), _c('div', {
      staticClass: "small-8 columns text-left summary-value"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formatValue(fee.amount)))])])])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    class: ['promo-info' + (_vm.showPromoCodeInput ? '' : ' hide')]
  }, [_c('div', {
    staticClass: "row padding-h-m"
  }, [(_vm.flashData.type == 'redeem') ? _c('div', {
    class: ['alert-wrap showhide-fadeslide', (_vm.flashData.message === '' ? 'hide' : '')]
  }, [_c('div', {
    class: ['alert margin-b-s', _vm.flash.notice],
    domProps: {
      "innerHTML": _vm._s(_vm.flashData.message)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns summary-label"
  }, [_c('p', {
    staticClass: "margin-a-z promo-label"
  }, [_vm._v(_vm._s(_vm.$t('payment.credits')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [_c('p', {
    staticClass: "margin-a-z promo-value"
  }, [_c('strong', [_vm._v("(" + _vm._s(_vm.applyCurrency(_vm.addZero(_vm.credits), true, false)) + ")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t-s padding-r-s"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('div', {
    staticClass: "field-group redeemWrap"
  }, [_c('div', {
    staticClass: "field-combo"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.promoCode),
      expression: "promoCode"
    }],
    staticClass: "field-text",
    attrs: {
      "placeholder": "Promo/Discount code",
      "disabled": _vm.redeemLoading
    },
    domProps: {
      "value": (_vm.promoCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.promoCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field-button btn-dark text-center",
    on: {
      "click": _vm.redeemCode
    }
  }, [_c('button', {
    class: ['padding-a-s redeemBtn', (_vm.redeemLoading ? 'loading' : '')]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.redeemLoading),
      expression: "!redeemLoading"
    }],
    staticClass: "original-label"
  }, [_vm._v(_vm._s(_vm.$t('payment.redeem')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.redeemLoading),
      expression: "redeemLoading"
    }],
    staticClass: "loaderx"
  }, [_c('icon', {
    staticClass: "magin-r-xs",
    attrs: {
      "name": "refresh",
      "spin": ""
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "price-info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('h2', {
    staticClass: "font-normal margin-a-z"
  }, [_vm._v(_vm._s(_vm.$t('payment.total')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-8 columns text-left summary-value"
  }, [(_vm.currency.code === 'USD') ? _c('h2', {
    staticClass: "margin-a-z total"
  }, [_vm._v(_vm._s(_vm.applyCurrency(_vm.addZero(_vm.total))))]) : _c('h2', {
    staticClass: "margin-a-z total"
  }, [_vm._v(_vm._s(_vm.totalIntl))])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d1a5ebe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d1a5ebe","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Payment/PaymentSummaryForm.vue
// module id = 2120
// module chunks = 0